import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { DocumentPreviewDetailEntity } from "domain/entity/DocumentPreview/DocumentPreviewDetailEntity";
import { DocumentPreviewEntity } from "domain/entity/DocumentPreview/DocumentPreviewEntity";
import { DocumentPreviewRequestEntity } from "domain/entity/DocumentPreview/DocumentPreviewRequestEntity";
import { DocChargeDataCriteria } from "presentation/constant/DocumentPreview/DocChargeDataCriteria";
import { DocumentPreviewEditSearchCriteria } from "presentation/constant/DocumentPreview/DocumentPreviewEditSearchCriteria";
import { DocumentPreviewFirstPrintCriteria } from "presentation/constant/DocumentPreview/DocumentPreviewFirstPrintCriteria";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import chargeAxiosInstance from "../axios/chargeAxiosInstance";
import documentAxiosInstance from "../axios/documentAxiosInstance";
import { DocumentPreviewRepository } from "./DocumentPreviewRepo";

export const DocumentPreviewRepoImpl = (): DocumentPreviewRepository => {
    const url = "/v1/documentPreview";

    const searchDocPreviewData = async (requestEntity: DocumentPreviewRequestEntity): Promise<DocumentPreviewEntity[]> => {
        const newUrl = url + "/search";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const searchInvoiceItemDtl = async (requestEntity: DocumentPreviewRequestEntity): Promise<DocumentPreviewDetailEntity[]> => {
        const newUrl = url + "/searchInvItemDtl";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const finalize = async (requestEntity: DocumentPreviewRequestEntity): Promise<ResponseEntity> => {
        const newUrl = url + "/finalize";

        try {
            return await axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity) as ResponseEntity;
        } catch (err) {
            throw err;
        }
    }

    const save = async (requestEntity: DocumentPreviewRequestEntity): Promise<Object> => {
        const newUrl = url + "/save";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const reject = async (requestEntity: DocumentPreviewRequestEntity): Promise<Object> => {
        const newUrl = url + "/reject";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const apply = async (requestEntity: DocumentPreviewRequestEntity): Promise<Object> => {
        const newUrl = url + "/apply";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const searchDataForMove = async (requestEntity: DocumentPreviewRequestEntity): Promise<DocumentPreviewEntity[]> => {
        const newUrl = url + "/searchDataForMove";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const addOrApplyDocDataForMove = async (requestEntity: DocumentPreviewRequestEntity): Promise<Boolean> => {
        const newUrl = url + "/addOrApplyDocDataForMove";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const previewDocReport = async (requestEntity: DocumentPreviewRequestEntity): Promise<any> => {
        const newUrl = url + "/previewDocReport";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const previewSupportingReport = async (requestEntity: DocumentPreviewRequestEntity): Promise<any> => {
        const newUrl = url + "/previewSupportingReport";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const printAndSent = async (requestEntity: DocumentPreviewFirstPrintCriteria): Promise<ResponseEntity> => {
        const newUrl = url + "/printAndSent";

        try {
            return await axiosPostData(documentAxiosInstance, `${newUrl}`, requestEntity) as ResponseEntity;
        } catch (err) {
            throw err;
        }
    }

    const searchDocChargeData = async (editSearchCriteria: DocumentPreviewEditSearchCriteria): Promise<ResponseEntity> => {
        const newUrl = "/v1/documentAddRemoveCntr/searchDocChargeData";

        return await axiosPostData(documentAxiosInstance, `${newUrl}`, editSearchCriteria) as ResponseEntity;
    }

    const submitDocChargeData = async (criteria: DocChargeDataCriteria): Promise<ResponseEntity> => {
        const newUrl = "/v1/documentAddRemoveCntr/submitDocChargeData";

        return await axiosPostData(documentAxiosInstance, `${newUrl}`, criteria) as ResponseEntity;
    }

    const approveRejectDocChargeData = async (criteria: DocChargeDataCriteria): Promise<ResponseEntity> => {
        const newUrl = "/v1/documentAddRemoveCntr/approveRejectDocChargeData";

        return await axiosPostData(documentAxiosInstance, `${newUrl}`, criteria) as ResponseEntity;
    }

    const checkAddRemoveCharge = async (criteria: DocumentPreviewEditSearchCriteria): Promise<ResponseEntity> => {
        const newUrl = "/v1/checkAddRemoveCharge";

        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, criteria) as ResponseEntity;
    }


    return {
        approveRejectDocChargeData: approveRejectDocChargeData,
        checkAddRemoveCharge: checkAddRemoveCharge,
        submitDocChargeData: submitDocChargeData,
        searchDocPreviewData: searchDocPreviewData,
        searchInvoiceItemDtl: searchInvoiceItemDtl,
        finalize: finalize,
        save: save,
        reject: reject,
        apply: apply,
        searchDataForMove: searchDataForMove,
        addOrApplyDocDataForMove: addOrApplyDocDataForMove,
        previewDocReport: previewDocReport,
        previewSupportingReport: previewSupportingReport,
        printAndSent: printAndSent,
        searchDocChargeData: searchDocChargeData,
    }
}